import { Component, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/services/toast-service.service';
import { Dependent } from 'src/app/core/models/dependent';
import { DependentService } from 'src/app/core/services/general/dependent.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-member-otp-verification',
  templateUrl: './member-otp-verification.component.html',
  styleUrls: ['./member-otp-verification.component.scss']
})

export class MemberOtpVerificationComponent implements OnDestroy {
  @Input() dependent!: Dependent;
  public form!: FormGroup;
  public countDown: number = 0;
  intervalId: any;
  public loading: boolean = false;
  public otpHasBeenRequested: boolean = false;
  public showValidationErrors = false;

  public videoOptions: MediaTrackConstraints = {
    width: { ideal: 400 },
    height: { ideal: 400 }
  };


  constructor(
    public activeModal: NgbActiveModal,
    public fb: FormBuilder,
    private toastService: ToastService,
    private alertService: AlertService,
    private dependentService: DependentService
  ) {
    this.form = this.fb.group({
      one_time_password: ['', [Validators.required]],
    });
  }

  startInterval() {
    this.countDown = 60;
    this.intervalId = setInterval(() => {
      this.countDown--;
      if (this.countDown == 0) {
        this.stopInterval();
      }
    }, 1000);
  }

  stopInterval() {
    clearInterval(this.intervalId);
  }

  /**
   * Stage 5 PR 15 — clear the resend-OTP countdown timer on destroy
   * so it doesn't keep ticking after the modal is dismissed.
   */
  ngOnDestroy(): void {
    this.stopInterval();
  }


  requestOneTimePassword() {
    this.loading = true;
    const formData = new FormData();
    formData.append(
      'member_number',
      this.dependent.member_number
    );
    formData.append(
      'beneficiary_number',
      this.dependent.beneficiary_number
    );
    formData.append(
      'national_id',
      this.dependent.national_id ?? ''
    );
    this.dependentService
      .requestDependentOneTimePassword(formData)
      .subscribe(
        (res: any) => {
          this.loading = false;
          this.otpHasBeenRequested = true;
          this.toastService.showSuccess("Member One-Time Password (OTP) has been sent.");
          this.startInterval();
        },
        (error: any) => {
          this.loading = false;
          this.alertService.showNotificationForHttpError(error);
        }
      );
  }

  verifyOneTimePassword() {
    if (!this.form.valid) {
      this.toastService.showError("Please, enter your OTP to proceed.", 'Attention!');
      return;
    }
    this.loading = true;
    const formData = new FormData();
    formData.append(
      'member_number',
      this.dependent.member_number
    );
    formData.append(
      'beneficiary_number',
      this.dependent.beneficiary_number
    );
    formData.append(
      'national_id',
      this.dependent.national_id ?? ''
    );
    formData.append(
      'one_time_password',
      this.form.get('one_time_password')?.value ?? ''
    );
    this.dependentService
      .verifyDependentOneTimePassword(formData)
      .subscribe(
        {
          next: (res: any) => {
            this.loading = false;
            this.activeModal.close(res);
          },
          error: (err: any) => {
            this.loading = false;
            if (err.error.message) {
              this.toastService.showError(err.error.message);
            } else {
              this.toastService.showError(
                'An error occurred. Please, check your internet connection and try again.'
              );
            }
          },
        }
      );
    return
  }


}
